module.exports = __webpack_public_path__ + "static/logo-white-2806e643172a9994a3b69d6822c42c9b.png";